import React from 'react';
import { IconProps } from '.';

const SvgCircleXFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Z' />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M10.94 12 7.47 8.53l1.06-1.06L12 10.94l3.47-3.47 1.06 1.06L13.06 12l3.47 3.47-1.06 1.06L12 13.06l-3.47 3.47-1.06-1.06L10.94 12Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCircleXFill;
